/* file description */
import React, { FC, useState, useEffect } from 'react';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';

import { ReferenceRenderProps } from './type';
import { COLUMN_FROM } from '../../effects/consts';

export const ProductSelelctRender: FC<ReferenceRenderProps> = ({
  field,
  API,
  targerValue,
  rowsData,
  columnFrom,
  setViewValue,
}) => {
  const { detailModule = 'md_cpart_product_base_info' } = field?.bizConfig || {};
  const [renderData, setRenderData] = useState<any>('');

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  useEffect(() => {
    if (!targerValue) {
      return;
    }
    const fieldDataList: any[] = [];
    if (columnFrom === COLUMN_FROM.TABLE) {
      rowsData?.forEach((item: any) => {
        if (item[field.name]) {
          fieldDataList.push(item[field.name]);
        }
      });
    } else {
      fieldDataList.push(targerValue);
    }
    if (fieldDataList.length < 1) {
      return;
    }
    const targetSql = fieldDataList.map((fV) => `'${fV}'`).join(',');
    const params: Record<any, any> = {
      moduleID: detailModule,
      namespaceID: 'master_data',
      filter: `product_code in (${targetSql})`,
    };
    getModuleRecordListCache(API?.FetchAPI, params.namespaceID, params.moduleID, params).then((res: any) => {
      const { set = [] } = res || {};
      const listData = set.map((r: any) => convert(r));
      const findDictItem = listData?.find((item: Record<any, any>) => item.product_code === targerValue) || {};
      setRenderData(findDictItem.product_name || targerValue);
    });
  }, [rowsData]);

  useEffect(() => {
    setViewValue?.(renderData);
  }, [renderData]);

  return renderData;
};
export default ProductSelelctRender;
